export const NEW_PENDING_ACADEMY_ACTION = 'NEW_PENDING_ACADEMY_ACTION'
export const NEW_RESET_ACADEMY_ACTION = 'NEW_RESET_ACADEMY_ACTION'
export const NEW_SET_ACADEMY_DATA = 'NEW_SET_ACADEMY_DATA'
export const RESET_ACADEMY = 'RESET_ACADEMY'
